(function () {

  function getChairHandles() {
    try {
      const el = document.getElementById('pillow-chair-handles');
      return el ? JSON.parse(el.textContent) : [];
    } catch(e) { return []; }
  }

  function getActiveAddons() {
    try {
      const el = document.getElementById('pillow-active-addons');
      return el ? JSON.parse(el.textContent) : [];
    } catch(e) { return []; }
  }

  const NECK = {
    handle: "ttracing-threadmark-pillow",
    zakekeUrl: "apps/zakeke?pid=7967964823614&handle=ttracing-threadmark-pillow&locale=en",
    image: "//ttracing.my/cdn/shop/files/1-threadmark-pillow-black_400x.png?v=1770361711",
    label: "Personalize neck pillow",
    price: "+RM 79",
    cls: "addon-line-neck"
  };

  const LUMBAR = {
    handle: "ttracing-threadmark-lumbar-pillow",
    zakekeUrl:
      "apps/zakeke?pid=8079445131326&handle=ttracing-threadmark-lumbar-pillow&locale=en",
    image:
      "//ttracing.my/cdn/shop/files/1-threadmark-lumbar-pillow-black_73dbac8c-6bb9-4549-90e5-f87da717c53f_400x.png?v=1778056793",
    label: "Personalize lumbar pillow",
    price: "+RM 99",
    cls: "addon-line-lumbar",
  };

  let isProcessing = false;

  async function updateAddonLine() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const chairHandles = getChairHandles();
      const chairItems  = cart.items.filter(item => chairHandles.includes(item.handle));

      // Stamp data-is-pillow-chair for qty listener
      cart.items.forEach(item => {
        const el = document.querySelector(`.cart__item[data-key="${item.key}"]`);
        if (el) el.dataset.isPillowChair = chairHandles.includes(item.handle) ? 'true' : 'false';
      });
      const neckItems   = cart.items.filter(item => item.handle === NECK.handle);
      const lumbarItems = cart.items.filter(item => item.handle === LUMBAR.handle);

      renderAddonUI(chairItems, neckItems, lumbarItems);
    } catch (err) {
      console.error("Cart page addon check failed", err);
    } finally {
      isProcessing = false;
    }
  }

  function renderAddonUI(chairItems, neckItems, lumbarItems) {
    chairItems.forEach(chair => {
      const matchingRow = document.querySelector(`.cart__item[data-key="${chair.key}"]`);
      if (!matchingRow) return;

      const activeAddons = getActiveAddons();
      const neckLinked   = !activeAddons.includes(NECK.handle)   || neckItems.filter(p   => Number(p.properties?._linked_chair_variant_id) === chair.variant_id).length >= chair.quantity;
      const lumbarLinked = !activeAddons.includes(LUMBAR.handle) || lumbarItems.filter(p => Number(p.properties?._linked_chair_variant_id) === chair.variant_id).length >= chair.quantity;

      const existingWrapper = matchingRow.querySelector('.addon-lines-wrapper');

      // Skip re-render if linked state hasn't changed
      if (existingWrapper) {
        const sameNeck   = existingWrapper.dataset.neckLinked   === String(neckLinked);
        const sameLumbar = existingWrapper.dataset.lumbarLinked === String(lumbarLinked);
        if (sameNeck && sameLumbar) return;
        existingWrapper.remove();
      }

      if (neckLinked && lumbarLinked) return;

      const priceCol = matchingRow.querySelector('.cart__item-price-col');
      if (!priceCol) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'addon-lines-wrapper';
      wrapper.dataset.neckLinked   = String(neckLinked);
      wrapper.dataset.lumbarLinked = String(lumbarLinked);

      if (!neckLinked)   wrapper.appendChild(buildAddonDiv(NECK, chair.variant_id));
      if (!lumbarLinked) wrapper.appendChild(buildAddonDiv(LUMBAR, chair.variant_id));

      priceCol.insertAdjacentElement('afterend', wrapper);
    });

  }

  function buildAddonDiv(addon, chairVariantId) {
    const div = document.createElement('div');
    div.className = 'addon-line-custom ' + addon.cls;
    div.innerHTML = `
      <div class="pillow-img" style="display: flex; align-items: center; min-height: 45px;"><img src="${addon.image}"></div>
      <div class="addon-line-inner" style="display:flex; gap: 10px; justify-content:space-between; font-size:14px; align-items:center; flex:1;">
        <span>${addon.label} <span>${addon.price}</span></span>
        <a href="/${addon.zakekeUrl}&linked_chair=${chairVariantId}">Add On</a>
      </div>
    `;
    return div;
  }


  function bindCartPageChairListeners() {
    function isTargetChairItem(el) {
      const itemEl = el.closest('.cart__item');
      return itemEl && itemEl.dataset.isPillowChair === 'true';
    }

    function disableAddonLinks() {
      document.querySelectorAll('.addon-line-custom a, .cart-pillow-custom a').forEach(a => {
        a.style.pointerEvents = 'none';
        a.style.cursor = 'default';
      });
    }

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.js-qty__adjust');
      if (btn && isTargetChairItem(btn)) disableAddonLinks();
    }, true);

    document.addEventListener('change', (e) => {
      const input = e.target.closest('.js-qty__num');
      if (input && isTargetChairItem(input)) disableAddonLinks();
    }, true);
  }

  document.addEventListener('cart:updated', updateAddonLine);
  document.addEventListener('DOMContentLoaded', () => {
    updateAddonLine();
    bindCartPageChairListeners();
  });

})();
